import { CLASS_NAMES } from "./constants";
import { ModalHandler } from "./ModalHandler";

export class ModalListener extends ModalHandler {
  modal: HTMLElement | null;
  buttons: (HTMLElement | null)[];
  backdrop: Element | null;
  anchors: HTMLAnchorElement[] = [];
  constructor(protected elememt: HTMLElement) {
    super();
    const ariaControls: string[] = this.elememt.getAttribute("aria-controls")?.split(/\s/) ?? [];
    const controls: (HTMLElement | null)[] = ariaControls.map((control: string) => document.getElementById(control));
    this.modal = controls.find((control: HTMLElement | null) => control?.classList.contains(CLASS_NAMES.MODAL)) ?? null;
    this.buttons = controls.filter((control: HTMLElement | null) => control?.classList.contains(CLASS_NAMES.BUTTON));
    this.backdrop = this.modal?.getElementsByClassName(CLASS_NAMES.BACKDROP)[0] || null;
    this.anchors = this.modal
      ? [...this.modal.getElementsByTagName("a")].filter(
          (a: HTMLAnchorElement) =>
            (a.origin === location.origin && a.pathname === location.pathname) || a.href.startsWith("#")
        )
      : [];
  }

  listen() {
    this.elememt.addEventListener(
      "click",
      this.handleClick.bind(this.elememt, this.modal, [this.elememt, ...this.buttons], this)
    );
  }

  listenClose() {
    window.addEventListener(
      "keydown",
      this.handleKeyDown.bind(this.elememt, this.modal, [this.elememt, ...this.buttons], this)
    );
    this.backdrop?.addEventListener("click", this.close.bind(this, this.modal, [this.elememt, ...this.buttons], this));
    this.anchors.forEach(
      (a) => this.modal && a.addEventListener("click", this.handleAnchor.bind(a, this.modal, this.buttons, this))
    );
  }

  unlisten() {
    window.removeEventListener(
      "keydown",
      this.handleKeyDown.bind(this.elememt, this.modal, [this.elememt, ...this.buttons], this)
    );
    this.backdrop?.removeEventListener(
      "click",
      this.close.bind(this, this.modal, [this.elememt, ...this.buttons], this)
    );
    this.anchors.forEach(
      (a) => this.modal && a.removeEventListener("click", this.handleAnchor.bind(a, this.modal, this.buttons, this))
    );
  }
}
